'use client';

import React from 'react';

export const useStateRef = <T extends unknown>(
  processNode: (node: HTMLElement) => T,
): [T | undefined, (node: HTMLElement) => void] => {
  const [node, setNode] = React.useState<T | undefined>(undefined);
  const setRef = React.useCallback(
    (newNode: HTMLElement) => {
      setNode(processNode(newNode));
    },
    [processNode],
  );
  return [node, setRef];
};
